var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 6.20509H9.25586V12.8125C9.25586 12.8985 9.32617 12.9688 9.41211 12.9688H10.584C10.6699 12.9688 10.7402 12.8985 10.7402 12.8125V6.20509H12.1875C12.3184 6.20509 12.3906 6.0547 12.3105 5.95314L10.123 3.18361C10.1084 3.16493 10.0898 3.14983 10.0684 3.13944C10.0471 3.12906 10.0237 3.12366 10 3.12366C9.97629 3.12366 9.95288 3.12906 9.93156 3.13944C9.91024 3.14983 9.89157 3.16493 9.87695 3.18361L7.68945 5.95119C7.60938 6.0547 7.68164 6.20509 7.8125 6.20509ZM17.1484 12.2266H15.9766C15.8906 12.2266 15.8203 12.2969 15.8203 12.3828V15.3906H4.17969V12.3828C4.17969 12.2969 4.10938 12.2266 4.02344 12.2266H2.85156C2.76562 12.2266 2.69531 12.2969 2.69531 12.3828V16.25C2.69531 16.5957 2.97461 16.875 3.32031 16.875H16.6797C17.0254 16.875 17.3047 16.5957 17.3047 16.25V12.3828C17.3047 12.2969 17.2344 12.2266 17.1484 12.2266Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.95881c399b025864f3f980d877729c38.svg";
export { ForwardRef as ReactComponent };